import { DiscountType, Type as RewardType } from '@wix/ambassador-loyalty-referral-v1-program/types';
import { ScopeNamespace } from './constants';
const DEFAULT_DISCOUNT_TRANSLATION_KEY = 'friend.title.discount.stores';
const discountTranslationKeyMap = {
  [ScopeNamespace.Stores]: DEFAULT_DISCOUNT_TRANSLATION_KEY,
  [ScopeNamespace.Bookings]: 'friend.title.discount.bookings',
  [ScopeNamespace.Events]: 'friend.title.discount.events',
  [ScopeNamespace.PricingPlans]: 'friend.title.discount.pricing-plans',
  [ScopeNamespace.Restaurants]: 'friend.title.discount.restaurants',
  [ScopeNamespace.OnlinePrograms]: 'friend.title.discount.online-programs'
};
const getDiscountTranslationKey = scope => {
  if (!(scope != null && scope.namespace)) {
    return DEFAULT_DISCOUNT_TRANSLATION_KEY;
  }
  const namespace = scope.namespace;
  return discountTranslationKeyMap[namespace] ?? DEFAULT_DISCOUNT_TRANSLATION_KEY;
};
export function getFriendTitle(_ref, program) {
  let {
    t,
    formatNumber,
    formatCurrency,
    customPointsName
  } = _ref;
  const reward = program.referredFriendReward;
  if (!reward) {
    return t('friend.title.default');
  }
  if (reward.type === RewardType.COUPON) {
    const {
      couponOptions
    } = reward;
    if ((couponOptions == null ? void 0 : couponOptions.discountType) === DiscountType.FREE_SHIPPING) {
      return t('friend.title.free-shipping');
    } else if ((couponOptions == null ? void 0 : couponOptions.discountType) === DiscountType.PERCENTAGE) {
      var _couponOptions$percen;
      const amount = couponOptions == null || (_couponOptions$percen = couponOptions.percentageOptions) == null ? void 0 : _couponOptions$percen.percentage;
      if (amount !== undefined) {
        const percentage = `${formatNumber(amount)}%`;
        return t(getDiscountTranslationKey(couponOptions == null ? void 0 : couponOptions.scope), {
          amount: percentage
        });
      }
    } else if ((couponOptions == null ? void 0 : couponOptions.discountType) === DiscountType.FIXED_AMOUNT) {
      var _couponOptions$fixedA;
      const amount = couponOptions == null || (_couponOptions$fixedA = couponOptions.fixedAmountOptions) == null ? void 0 : _couponOptions$fixedA.amount;
      if (amount !== undefined) {
        return t(getDiscountTranslationKey(couponOptions == null ? void 0 : couponOptions.scope), {
          amount: formatCurrency(amount)
        });
      }
    }
  } else if (reward.type === RewardType.LOYALTY_POINTS) {
    var _reward$loyaltyPoints;
    const amount = (_reward$loyaltyPoints = reward.loyaltyPointsOptions) == null ? void 0 : _reward$loyaltyPoints.amount;
    if (amount !== undefined) {
      if (customPointsName) {
        return t('friend.title.points.custom', {
          amount: formatNumber(amount),
          pointsName: customPointsName
        });
      } else {
        return t('friend.title.points', {
          amount,
          formattedAmount: formatNumber(amount)
        });
      }
    }
  }
  return t('friend.title.default');
}
//# sourceMappingURL=getFriendTitle.js.map